import RejectButton from './RejectButton';

import ApproveButton from './ApproveButton';
import SaveButton from './SaveButton';
import PublishWithoutApprovalButton from './PublishWithoutApprovalButton';

import React, { useContext } from 'react';
import { UserContext } from 'context/UserContext';

import { Approval } from 'models/approval';
import DropDownHeaderButtons from './DropDownHeaderButtons';

type ApprovalButtonProps = {
  approval?: Approval;
  save: () => void;

  addApproveCommand: (message: string) => void;
  addRejectCommand: (message: string) => void;
  addPublishCommand: (message: string) => void;
};

const ApprovalButtons = ({
  save,
  addApproveCommand,
  addRejectCommand,
  addPublishCommand,
  approval
}: ApprovalButtonProps) => {
  const { user } = useContext(UserContext);
  const corporateUser = user.corporateUser;
  let buttons: JSX.Element[];
  if (corporateUser && approval?.requested) {
    buttons = [<RejectButton addRejectCommand={addRejectCommand!} />, <ApproveButton addApproveCommand={addApproveCommand!} />];
  } else {
    const legacyReview = !corporateUser && (approval?.requested || approval?.rejected);
    buttons = [<SaveButton save={save} />, <PublishWithoutApprovalButton text='Publish' addCommand={addPublishCommand!} legacyReview={legacyReview} />];
  }

  return (
    <>
      <div className='hidden md:flex items-center'>{buttons.map((button, index) => React.cloneElement(button, { key: index }))}</div>
      <div className='sm:flex items-center'>
        <DropDownHeaderButtons buttons={buttons} />
      </div>
    </>
  );
};

export default ApprovalButtons;
